import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/static/img/logo-icon.svg'


const _hoisted_1 = { class: "side-nav-body" }
const _hoisted_2 = { class: "side-nav-items" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "side-nav-items secondary" }
const _hoisted_7 = { class: "modal-inner" }
const _hoisted_8 = { class: "user-item" }
const _hoisted_9 = {
  class: "user-popup-wrapper",
  "data-interactive": ""
}
const _hoisted_10 = { class: "side-nav-user" }
const _hoisted_11 = {
  key: 0,
  class: "user-popup"
}
const _hoisted_12 = { class: "user-popup-title" }
const _hoisted_13 = {
  key: 0,
  class: "user-popup-subtitle"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["title"]

import { computed, ref } from 'vue';
import { clearNull, formatNameInitials } from '@/utils/main';
import store from "@/store";
import VitaDrop from '@/components/UI/VitaDrop.vue';
import VitaIcon from './UI/VitaIcon.vue';
import VitaPrintTable from '@/components/VitaPrintTable.vue';
import VitaInfoModal from '@/components/UI/VitaInfoModal.vue';
import VitaReportDrop from '@/components/VitaReportDrop.vue';
import AuthenticationRestoreDialog from '@/components/AuthenticationRestoreDialog.vue';
import router from '@/router';
import { isNavigationFailure, NavigationFailureType } from 'vue-router';
import { reachGoal } from '@/utils/metrika';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaSideNav',
  setup(__props) {

const userName = computed(() => {
  return clearNull(store.getters["user/userName"]);
})

const userPosition = computed(() => {
  return store.getters['user/userPosition']
})

const userPositionBid = computed(() => {
  return store.getters['user/userPositionBid']
})

const isGurvRole = computed<boolean>(() => {
  return store.getters['getGurvRole']
})

const isOffice = computed(() => {
  return store.getters['getOfficeState']
})

const isBeruAccessRole = computed<boolean>(() => {
  return store.getters['getBeruAccessRole']
})

const modalTitle = ref<string>('Вы действительно хотите выйти?')
const openLogoutModal = ref<boolean>(false)
const openPasswordModal = ref<boolean>(false)
const openSettingsDrop = ref<boolean>(false)
const openReportDrop = ref<boolean>(false)
const printModal = ref({ open: false })
const inProcess = ref(false);

const toggleSettingsDrop = () => {
  openSettingsDrop.value = !openSettingsDrop.value
}

const closeSettingsDrop = () => {
  openSettingsDrop.value = false
}

const toggleReportDrop = () => {
  openReportDrop.value = !openReportDrop.value
  reachGoal('sidenav-report-click')
}

const closeReportDrop = () => {
  openReportDrop.value = false
}

const closePrintModal = () => {
  printModal.value.open = false
}

const openPrintModal = () => {
  printModal.value.open = true
}

const logout = async () => {
  try {
    inProcess.value = true
    await store.dispatch('user/logout')
    store.commit('clearDates') // Сбрасываем даты в состоянии, чтобы предотвратить сохранение после выхода
    store.commit('clearShiftBuffer') // Сбрасываем скопированные смены в состоянии
    // Очистка поиска аптек
    store.commit('data/setPharmSkip', 0)
    store.commit('data/setPharmSearchQuery', '')

    // Очистка поиска внешних пользователей
    store.commit('data/setUserSearchSkip', 0)
    store.commit('data/setUserSearchList', null)
    store.commit('setUnsavedChanges', false)
    // Очистка открытых модалок создания смен
    store.commit('data/clearOpenedCreateShift')
    // Сброс меню
    store.commit('resetSidebarState')
    reachGoal('sidenav-logout-click')
  } catch (e) {
    console.error(e)
  } finally {
    inProcess.value = false
  }
}

const collapsedSidebar = computed(() => store.getters['getSidebarState'])
const collapseBtnTitle = computed(() => {
  return collapsedSidebar.value ? 'Раскрыть панель меню' : undefined
})

const toggleSidebar = (e: Event) => {
  e.preventDefault()
  store.commit('setSidebarState', !collapsedSidebar.value)
  reachGoal('sidenav-toggle-click')
}

const toggleSidebarOnBlankSpace = (e: MouseEvent) => {
  if (!(e.target instanceof Element)) return

  const interactiveElement = e.target.closest('button, a, input, textarea, select, [data-interactive]')
  if (interactiveElement) return

  store.commit('setSidebarState', !collapsedSidebar.value)
  reachGoal('sidenav-click')
}

const openBeruService = () => {
  router.push('/beru').then((failure) => {
    if (isNavigationFailure(failure, NavigationFailureType.duplicated)) return
    reachGoal('sidenav-beru-route')
  });
}

const openTimetable = () => {
  router.push('/').then((failure) => {
    if (isNavigationFailure(failure, NavigationFailureType.duplicated)) return
    reachGoal('sidenav-timetable-route')
  });
}

const onPassChangeClick = () => {
  openPasswordModal.value = true
  reachGoal('sidenav-change-password-click')
}

return (_ctx: any,_cache: any) => {
  const _component_vita_button = _resolveComponent("vita-button")!
  const _component_vita_modal = _resolveComponent("vita-modal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: "side-nav",
    onClick: toggleSidebarOnBlankSpace,
    "data-qa": "side-nav-blank-space-toggle"
  }, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "side-nav-logo" }, [
      _createElementVNode("img", {
        width: "48",
        height: "48",
        alt: "Вита",
        src: _imports_0
      })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "side-nav-btn",
              type: "button",
              title: "График",
              onClick: openTimetable,
              "data-interactive": "",
              "data-qa": "side-nav-button-timetable"
            }, [
              _createVNode(VitaIcon, { name: "schedule" }),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "График", -1))
            ])
          ]),
          (_ctx.$route.path !== '/beru')
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createElementVNode("button", {
                  class: "side-nav-btn",
                  type: "button",
                  onClick: openPrintModal,
                  title: "Печать",
                  "data-interactive": "",
                  "data-qa": "side-nav-button-print"
                }, [
                  _createVNode(VitaIcon, { name: "print-lg" }),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "Печать", -1))
                ]),
                _createVNode(VitaInfoModal, {
                  open: printModal.value.open,
                  onToggleInfoModal: closePrintModal,
                  title: "Печатный вид графика",
                  "modal-icon": false,
                  "modal-size": "medium"
                }, {
                  default: _withCtx(() => [
                    _createVNode(VitaPrintTable)
                  ]),
                  _: 1
                }, 8, ["open"])
              ]))
            : _createCommentVNode("", true),
          (isGurvRole.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("button", {
                  class: _normalizeClass({'active' : openReportDrop.value, 'side-nav-btn' : true}),
                  type: "button",
                  onClick: toggleReportDrop,
                  title: "Отчет",
                  "data-interactive": "",
                  "data-qa": "side-nav-button-report-toggle"
                }, [
                  _createVNode(VitaIcon, { name: "calendar" }),
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "Отчет", -1))
                ], 2),
                _createVNode(_Transition, { name: "fade-ease" }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(VitaDrop, {
                      isOpen: openReportDrop.value,
                      class: "report-drop"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(VitaReportDrop, { "is-open": true })
                      ]),
                      _: 1
                    }, 8, ["isOpen"])), [
                      [_directive_click_outside, closeReportDrop]
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (isBeruAccessRole.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createElementVNode("button", {
                  class: "side-nav-btn",
                  type: "button",
                  title: "Сервис Беру!",
                  onClick: openBeruService,
                  "data-interactive": "",
                  "data-qa": "side-nav-button-beru"
                }, [
                  _createVNode(VitaIcon, { name: "service-beru" }),
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, [
                    _createTextVNode("Сервис "),
                    _createElementVNode("br"),
                    _createTextVNode(" Беру!")
                  ], -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: _normalizeClass({'active' : openSettingsDrop.value, 'side-nav-btn' : true}),
              type: "button",
              onClick: toggleSettingsDrop,
              title: "Настройки",
              "data-interactive": "",
              "data-qa": "side-nav-button-settings-toggle"
            }, [
              _createVNode(VitaIcon, { name: "settings" }),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "Настройки", -1))
            ], 2),
            _createVNode(_Transition, { name: "fade-ease" }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(VitaDrop, {
                  isOpen: openSettingsDrop.value,
                  class: "settings-drop"
                }, {
                  default: _withCtx(() => [
                    (!isOffice.value)
                      ? (_openBlock(), _createBlock(_component_vita_button, {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (onPassChangeClick())),
                          color: "blue",
                          "data-qa": "side-nav-button-change-password"
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("Сменить пароль", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_vita_button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (openLogoutModal.value = true)),
                      color: "black",
                      "data-qa": "side-nav-button-logout"
                    }, {
                      default: _withCtx(() => [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "mr-10" }, "Выйти", -1)),
                        _createVNode(VitaIcon, { name: "enter-big" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["isOpen"])), [
                  [_directive_click_outside, closeSettingsDrop]
                ])
              ]),
              _: 1
            }),
            (openLogoutModal.value)
              ? (_openBlock(), _createBlock(_component_vita_modal, {
                  key: 0,
                  title: modalTitle.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vita_button, {
                      color: "red",
                      width: "inline",
                      disabled: inProcess.value,
                      onClick: logout,
                      "data-qa": "side-nav-button-logout-confirm"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Да", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_vita_button, {
                      color: "blue",
                      width: "inline",
                      disabled: inProcess.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (openLogoutModal.value = false)),
                      "data-qa": "side-nav-button-logout-cancel"
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("Нет", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (openPasswordModal.value)
              ? (_openBlock(), _createBlock(_component_vita_modal, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(VitaIcon, {
                        class: "modal-close",
                        name: "cross-dark",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (openPasswordModal.value = false)),
                        "data-qa": "side-nav-icon-password-modal-close"
                      }),
                      _createVNode(AuthenticationRestoreDialog, { "soft-reset": true })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatNameInitials)(userName.value)), 1),
              (userName.value || userPosition.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(userName.value), 1),
                    (userPosition.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("span", null, _toDisplayString(userPosition.value), 1),
                          (userPositionBid.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(" + _toDisplayString(userPositionBid.value) + ")", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("button", {
          class: "side-nav-control",
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSidebar($event))),
          title: collapseBtnTitle.value,
          "data-interactive": "",
          "data-qa": "side-nav-button-collapse-toggle"
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("svg", {
            width: "13",
            height: "10",
            viewBox: "0 0 13 10",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M0.5 5L5.55735 4.12046e-08L6.5 0.931958L2.38528 5L6.5 9.06804L5.55735 10L0.5 5Z",
              fill: "white"
            }),
            _createElementVNode("path", {
              d: "M6.5 5L11.5573 4.12046e-08L12.5 0.931958L8.38528 5L12.5 9.06804L11.5573 10L6.5 5Z",
              fill: "white"
            })
          ], -1),
          _createElementVNode("span", null, "Скрыть", -1)
        ]))], 8, _hoisted_15)
      ])
    ])
  ]))
}
}

})